// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"78d7963a","516":"4dcdd00f"}[chunkId] + ".chunk.js";
};